import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { COLOR_FONT_0, COLOR_FONT_1 } from '../../colors';

/* eslint-disable max-statements */
export class SemiCirclePieChart extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.PieChart);
    chart.data = data;

    // -- display
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    chart.radius = am4core.percent(90);
    chart.innerRadius = am4core.percent(50);
    chart.startAngle = 160;
    chart.endAngle = 380;

    // -- series
    const series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = 'count';
    series.dataFields.category = 'name_display';
    // series.slices.template.cornerRadius = 4;
    // series.slices.template.innerCornerRadius = 2;
    series.slices.template.draggable = false;
    series.slices.template.inert = true;
    series.labels.template.disabled = true;
    series.hiddenState.properties.startAngle = 90;
    series.hiddenState.properties.endAngle = 90;

    // -- legend
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color(COLOR_FONT_1);
    chart.legend.valueLabels.template.fill = am4core.color(COLOR_FONT_0);
    chart.legend.position = 'left';

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ width: '100%', height: '544px' }} />;
  }
}

SemiCirclePieChart.propTypes = {
  chartId: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({ name_display: PropTypes.string.isRequired, count: PropTypes.number.isRequired })
  ).isRequired
};
